export const ROUTES = {
  HOME: "/",
  PROFILE: "/profile",
  CHATS: "/chats/:chatId",
  CHAT: "/chats/",
  DICTIONARY: "/dictionary",
  SIGN_IN: "/sign-in",
};
